'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';

import { MediaImage } from '@/elements/media-image/media-image.component';

import {
  CardWrapper,
  ImageWrap,
  Content,
  Title,
  Footer,
  Author,
  // Published,
} from './post-card.elements';

const PostCard = ({
  data: {
    slug,
    image,
    title,
    author,
    // publishedDate,
  },
}) => {
  const router = useRouter();

  return (
    <Link href={`/${slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
      <CardWrapper>
        <ImageWrap>
          <MediaImage
            variant="post"
            src={image?.sizes?.educationCard?.url}
            alt={image?.alt || title}
            width={300}
            height={215}
            style={{ objectFit: 'contain' }}
          />
        </ImageWrap>
        <Content>
          <Title>{title}</Title>
          <Footer>
            <Author
              onClick={() => router.push(`/autori/${author.id}`)}
            >{`${author.firstName} ${author.lastName}`}</Author>
            {/* <Published>
              {new Intl.DateTimeFormat('hr', {
                day: 'numeric',
                month: 'narrow',
                year: 'numeric',
              }).format(new Date(publishedDate))}
            </Published> */}
          </Footer>
        </Content>
      </CardWrapper>
    </Link>
  );
};

export { PostCard };
